import React from 'react'
import { connect } from 'react-redux'
import NewTable from '../components/tables/NewTable'
import {newTable, fetchSingleUsrTable} from '../actions/actions'
import { Redirect } from "react-router-dom"
import DisplayError from '../components/DisplayError';

class TablesContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      table: {
        cuppingNum: 1,
        date: new Date(),
        tname: "",
        tdescription: "",
        specialtyDefaults: true,
        publicCupping: true,
        justCreated: false,
      },
      cupping: {

      }     
    }
  }

  justCreatdToggle = () => {
    this.setState({
      ...this.state,
      table: {
        ...this.state.table,
        justCreated: !this.state.table.justCreated
      }
    })
  }

   tableSubmit = () => {
    this.justCreatdToggle()
    this.props.newTable(this.state.table, this.props.user.id, this.props.user.name)
    window.scrollTo(0, 0);
  }

  handleChange = event => {
    this.setState({
      ...this.state,
      table: {
        ...this.state.table,
        [event.target.name]: event.target.value
      }
    })
  } 
  
  handleDate = (newDate, prevState) => {
    this.setState({
      ...this.state,
      table: {
        // ...prevState,
        ...this.state.table,
        date: newDate
      }
    })
  }

  handleSwitch = event => {
    this.setState({
      ...this.state,
      table: {
        ...this.state.table,
        [event.target.name]: event.target.checked
      }
    })
  } 

  trimInput = event => {
    this.setState({
      ...this.state,
      table: {
        ...this.state.table,
         [event.target.name]: event.target.value.trim()
      }
    })
  }

  componentDidMount() {
    if (this.state.table.justCreated) {
      this.justCreatdToggle()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.singleTable !== prevProps.singleTable) {
         const tableId = window.location.pathname.replace("/tables/", "")
         this.props.fetchSingleUsrTable(tableId)
     }
}

  render(){
        // console.log(this.props)

        if (!!this.props.error && this.state.table.justCreated) {
          return <DisplayError errorMsg={this.props.error_msg} />
        }
        // props table created rcvd from NewTable after submit ok, then redirect to show page.
        else if (this.props.table && this.state.table.justCreated && this.props.singleTable) {
          return (
            <Redirect push to={{
              pathname: `/tables/${this.props.table.id}`,
              state: {justCreated: this.state.table.justCreated}
            }}/>
          )
        } else if (window.location.pathname === "/cuppings/new") {          
          return <NewTable CatadorName={this.props.user.name} handlechange={this.handleChange} handleDate={this.handleDate} cuppingNum={this.state.table.cuppingNum} date={this.state.table.date} tname={this.state.table.tname} tdescription={this.state.table.tdescription} tableSubmit={this.tableSubmit}
          specialtyDefaults={this.state.table.specialtyDefaults} publicCupping={this.state.table.publicCupping} handleSwitch={this.handleSwitch} trimInput={this.trimInput}/>
        }
    }
}

const msp = state => {
	return {
    isLoggedIn: state.users.isLoggedIn,
    user: state.users.user,
    table: state.cuppings.table,
    error: state.users.error,
    error_msg: state.users.error_msg,
    singleTable: state.cuppings.singleTable,
    // userTables: state.users.user.tables,
	 }
  };
  
  export default connect(msp, {
    newTable, fetchSingleUsrTable
  })(TablesContainer)